class ExtratoList {
  static get $inject() {
    return ['$scope', 'gql']
  }

  constructor($scope, gql) {
    this.gql = gql
    this.scope = $scope
    this.apply = (fn) => $scope.$applyAsync(fn)

    this.order = { sortField: 'EMISSAO', sortOrder: 'DESC' }
    this.filter = {}
    this.perPage = 20
    this.currentPage = 1

    this.sleep = (timeout) => {
      return new Promise((resolve) => {
        setTimeout(resolve, timeout)
      })
    }
  }

  $onChanges({ filter }) {
    if (filter) {
      this.filter = filter.currentValue
    }

    this.loadingPromise = this.loadExtratos()
  }

  sortBy(field) {
    let { sortField, sortOrder } = this.order

    if (field === sortField) {
      sortOrder = sortOrder === 'DESC' ? 'ASC' : 'DESC'
    } else {
      sortField = field
      sortOrder = 'ASC'
    }

    this.order = { sortField, sortOrder }
  }

  getSortingClass(field) {
    let { sortField, sortOrder } = this.order

    if (field !== sortField)
      return 'fa-unsorted'
    else
      return `fa-sort-${sortOrder.toLowerCase()}`
  }

  listLancamentos(extrato) {
    this.onListLancamentos({ extrato: extrato })
  }

  async loadExtratos(page = 1) {
    const query = gql`
      query ExtratosAII($empresaId: Int!, $filter: ExtratoFilter!, $paging: Paging!) {
        empresa: filial(id: $empresaId) {
          id
          extratosCount(filter: $filter)
          extratos(filter: $filter, paging: $paging) {
            id
            numero
            parcela
            referencia
            complemento
            receita
            situacaoCodigo
            situacaoDescricao
            dataVencimento
            valorLancamento
            dataAtualizacao
            valorAtualizacao
            lancamentosCount
          }
        }
      }
    `

    this.currentPage = page
    const paging = { limit: this.perPage, offset: (page - 1) * this.perPage }
    const variables = { empresaId: this.empresaId, filter: this.filter, paging }
    const { empresa: { extratos, extratosCount } } = await this.gql.query(query, variables)

    this.apply(() => {
      this.extratos = extratos
      this.extratosCount = extratosCount
    })
  }
}

angular.module('eficienciaFiscalModule').component('extratoList', {
  controller: ExtratoList,
  bindings: {
    filter: '<',
    empresaId: '<',
    onListLancamentos: '&'
  },
  template: `
    <loading promise="$ctrl.loadingPromise">
      <highlighted ng-show="$ctrl.extratos.length == 0">
        <main>Nenhuma informação encontrada.</main>
      </highlighted>
      <div ng-hide="$ctrl.extratos.length == 0">
        <paginator per-page="$ctrl.perPage" total="$ctrl.extratosCount" current-page="$ctrl.currentPage"
          on-change="$ctrl.loadExtratos($page)"></paginator>
        <div>
          <br />
          <table class="table">
            <thead>
              <tr>
                <th class="text-center" width="1">#</th>
                <th class="text-center no-break">Nº Lançamento</th>
                <th class="text-center">Parcela</th>
                <th class="text-center">Referência</th>
                <th class="text-center">Complemento</th>
                <th class="text-center">Receita</th>
                <th>Situação</th>
                <th class="text-center">Data vencimento</th>
                <th class="text-right">Valor lançamento</th>
                <th class="text-center">Data atualização</th>
                <th class="text-right">Valor atualizado</th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="extrato in $ctrl.extratos">
                <td class="text-center">{{ $index + 1 }}</td>
                <td class="text-center">
                  <a href="javascript:void(0)" ng-click="$ctrl.listLancamentos(extrato)"
                    ng-if="extrato.lancamentosCount > 0">
                    {{ extrato.numero }}
                  </a>
                  <span ng-if="extrato.lancamentosCount == 0">{{ extrato.numero }}</span>
                </td>
                <td class="text-center">{{ extrato.parcela }}</td>
                <td class="text-center">{{ extrato.referencia | date: 'MM/yyyy' }}</td>
                <td class="text-center">{{ extrato.complemento }}</td>
                <td class="text-center">{{ extrato.receita }}</td>
                <td ng-if="extrato.situacaoCodigo == null">{{ extrato.situacaoDescricao }}</td>
                <td ng-if="extrato.situacaoCodigo != null">{{ extrato.situacaoCodigo }} - {{ extrato.situacaoDescricao }}
                </td>
                <td class="text-center">{{ extrato.dataVencimento | date }}</td>
                <td class="text-right no-break">{{ extrato.valorLancamento | currency }}</td>
                <td class="text-center">{{ extrato.dataAtualizacao | date }}</td>
                <td class="text-right no-break">{{ extrato.valorAtualizacao | currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <paginator per-page="$ctrl.perPage" total="$ctrl.extratosCount" current-page="$ctrl.currentPage"
          on-change="$ctrl.pageChange($page)"></paginator>
      </div>
    </loading>
  `
})
